<template>
  <div class="pb-2 d-inline">
    <span
      :class="status ? 'active border-0 text-primary' : ''"
      class="p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent"
      @click="changeThisTab()"
    >
      <i :class="icon"></i> {{ label }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      default:false
    },
    label: {
      default:false
    },
    icon: {
      default:false
    },
    status: {
      default:false
    }
  },

  computed: {
  },
  created() {

  },

  methods: { 
    changeThisTab(){
      this.$emit('change',this.id)
    }

  },
};
</script>
</style>
